var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMakeASelection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "83px",
    height: "82px",
    viewBox: "0 0 83 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun_Location_2526962") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "web---make-a-selection",
    transform: "translate(-715.000000, -199.000000)",
    fill: "#444C54",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(566.000000, 200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Location_2526962",
    transform: "translate(150.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0055365,80 C31.6766291,80 31.3676139,79.8418966 31.1740078,79.5746552 C27.3073738,74.2394828 22.7926997,69.6139655 18.4265311,65.1405172 C8.98922097,55.4717241 0.0754532092,46.3393103 0.0754532092,32.2108621 C0.0754532092,23.6308621 3.39539441,15.5677586 9.42376286,9.50672414 C15.4521313,3.44568966 23.4717785,0.107758621 32.0055365,0.107758621 C49.6272905,0.107758621 63.9637433,14.5091379 63.9637433,32.2108621 C63.9637433,35.3881034 63.5235424,38.3736207 62.6177609,41.3381034 C62.4852033,41.7724138 62.0859873,42.0687931 61.6342969,42.0687931 L60.5340519,42.0687931 L60.5340519,46.2067241 C60.5340519,46.777931 60.0732729,47.2412069 59.5051445,47.2412069 L55.3895149,47.2412069 L55.3895149,54.0494828 C55.3895149,54.2853448 55.3092602,54.5141379 55.1622979,54.697931 C54.9512004,54.9618966 54.7371877,55.225 54.5211171,55.487069 C54.3256247,55.7244828 54.0351298,55.8618966 53.7286869,55.8618966 L43.3855953,55.8618966 L43.3855953,66.9853448 C43.3855953,67.2546552 43.2813327,67.5131034 43.0947575,67.7062069 C39.6530622,71.2681034 36.0283929,75.1712069 32.8372366,79.5746552 C32.6434591,79.8418966 32.3344439,80 32.0055365,80 Z M32.0055365,2.17672414 C15.5339294,2.17672414 2.13326801,15.65 2.13326801,32.2108621 C2.13326801,45.4936207 10.3643557,53.9267241 19.8952964,63.6915517 C24.0069819,67.9041379 28.2488241,72.25 32.005708,77.2317241 C34.9658746,73.307069 38.2149927,69.7960345 41.327952,66.5660345 L41.327952,54.8275862 C41.327952,54.2563793 41.788731,53.7931034 42.3568594,53.7931034 L53.2428711,53.7931034 C53.272538,53.7565517 53.3022048,53.72 53.3318716,53.6834483 L53.3318716,46.2068966 C53.3318716,45.6356897 53.7926507,45.1724138 54.360779,45.1724138 L58.4764086,45.1724138 L58.4764086,41.0344828 C58.4764086,40.4632759 58.9371877,40 59.505316,40 L60.8639882,40 C61.5646742,37.4739655 61.9061,34.917931 61.9061,32.2108621 C61.9061,15.65 48.4925772,2.17672414 32.0055365,2.17672414 Z",
    id: "Shape",
    stroke: "#444C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3606075,80 L42.3566879,80 C41.7885595,80 41.3277805,79.5367241 41.3277805,78.9655172 L41.3277805,54.8275862 C41.3277805,54.2563793 41.7885595,53.7931034 42.3566879,53.7931034 L54.3606075,53.7931034 C54.9287359,53.7931034 55.3895149,54.2563793 55.3895149,54.8275862 L55.3895149,78.9655172 C55.3895149,79.5367241 54.9287359,80 54.3606075,80 Z M43.3855953,77.9310345 L53.3317001,77.9310345 L53.3317001,55.862069 L43.3855953,55.862069 L43.3855953,77.9310345 Z",
    id: "Shape",
    stroke: "#444C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7403234,80 L71.5090642,80 C70.9409358,80 70.4801568,79.5367241 70.4801568,78.9655172 L70.4801568,58.2758621 C70.4801568,57.8681034 70.7185203,57.4982759 71.088584,57.3315517 C71.4589907,57.1651724 71.8919892,57.2325862 72.1943165,57.5041379 L80.4255757,64.8932759 C80.6442185,65.0896552 80.7692308,65.3703448 80.7692308,65.665 L80.7692308,78.9655172 C80.7692308,79.5367241 80.3084517,80 79.7403234,80 Z M72.5379716,77.9310345 L78.711416,77.9310345 L78.711416,66.1282759 L72.5379716,60.5862069 L72.5379716,77.9310345 Z",
    id: "Shape",
    stroke: "#444C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5090642,80 L54.3606075,80 C53.7924792,80 53.3317001,79.5367241 53.3317001,78.9655172 L53.3317001,46.2068966 C53.3317001,45.6356897 53.7924792,45.1724138 54.3606075,45.1724138 L71.5090642,45.1724138 C72.0771926,45.1724138 72.5379716,45.6356897 72.5379716,46.2068966 L72.5379716,78.9655172 C72.5379716,79.5367241 72.0771926,80 71.5090642,80 Z M55.3895149,77.9310345 L70.4801568,77.9310345 L70.4801568,47.2413793 L55.3895149,47.2413793 L55.3895149,77.9310345 Z",
    id: "Shape",
    stroke: "#444C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3645272,47.2413793 L59.5051445,47.2413793 C58.9370162,47.2413793 58.4762371,46.7781034 58.4762371,46.2068966 L58.4762371,41.0344828 C58.4762371,40.4632759 58.9370162,40 59.5051445,40 L66.3645272,40 C66.9326556,40 67.3934346,40.4632759 67.3934346,41.0344828 L67.3934346,46.2068966 C67.3934346,46.7781034 66.9326556,47.2413793 66.3645272,47.2413793 Z M60.5340519,45.1724138 L65.3356198,45.1724138 L65.3356198,42.0689655 L60.5340519,42.0689655 L60.5340519,45.1724138 Z",
    id: "Shape",
    stroke: "#444C54"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 57.7902989,
    y: 51.3793103,
    width: 3.42969133,
    height: 3.44827586
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 64.6496815,
    y: 51.3793103,
    width: 3.42969133,
    height: 3.44827586
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 57.7902989,
    y: 58.2758621,
    width: 3.42969133,
    height: 3.44827586
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 64.6496815,
    y: 58.2758621,
    width: 3.42969133,
    height: 3.44827586
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 57.7902989,
    y: 65.1724138,
    width: 3.42969133,
    height: 3.44827586
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 64.6496815,
    y: 65.1724138,
    width: 3.42969133,
    height: 3.44827586
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakeASelection);
export default __webpack_public_path__ + "static/media/make-a-selection.577180a36b624df2e07d42b7388033aa.svg";
export { ForwardRef as ReactComponent };